import { Modal } from 'react-bootstrap'
import styled, { css } from 'styled-components'

const v4 = css`
  text-transform: lowercase;
`

export const StyledModal = styled(Modal)`
  .modal-content {
    background: var(--clr-bg-2);
    padding: var(--2xl);
  }

  .modal-title {
    font-size: var(--h4);
    font-weight: bold;
    padding: 0 var(--2xl);
  }

  .close {
    position: absolute;
    top: var(--base);
    right: var(--lg);
  }

  ${props => props.version === 'v4' && v4}
`

export const DeviceFaceplateStyle = styled.div`
  flex-basis: 33%;
`

export const ActiveFilterStyle = styled.button`
  display: block;
  float: left;
  margin-left: 15px;
  margin-bottom: 5px;
  border: 0;
  border-radius: 3px;
  padding-left: 15px;

  @media screen and (max-width: 640px) {
    width: 100%;
    margin-left: 0px;
  }

  div {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    background-color: '#dddddd';
    border: none;
    color: #555;
    float: left;
    height: 35px;
    pointer-events: none;

    @media screen and (max-width: 640px) {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .input-group-addon {
      display: inline-block;
      width: 40px;
      height: 37px;
      background-color: #333;
      color: #999;
      border: none;
      font-size: var(--h5);
      margin-left: 10px;
      position: relative;
      left: 7px;
      top: -1px;

      .glyphicon {
        position: relative;
        top: 5px;
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/DeviceSelectModal/styles.js